import { Component, OnInit } from '@angular/core';
import { NgbDateNativeAdapter, NgbDateAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Entry } from 'src/app/models/entry';
import { EntryLine } from 'src/app/models/entry-line';
import { Article } from 'src/app/models/article';
import { Unity } from 'src/app/models/unity';
import { Warehouse } from 'src/app/models/warehouse';
import { PurchaseOrder } from 'src/app/models/purchase-order';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ArticleService } from 'src/app/services/article.service';
import { UnityService } from 'src/app/services/unity.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { InventoryService } from 'src/app/services/inventory-service';
import { Customer } from 'src/app/models/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { User } from 'src/app/models/user';

@Component({
  selector: 'app-entry-create',
  templateUrl: './entry-create.component.html',
  styleUrls: ['./entry-create.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class EntryCreateComponent implements OnInit {
  user:User = new User;
  actualUser:string = "";
  entry:Entry = new Entry();
  entryLine:EntryLine = new EntryLine();

  articles:Article[] = [];
  article:Article = null;
  unities:Unity[] = [];
  unity:Unity = null;
  warehouses:Warehouse[] = [];
  warehouse:Warehouse = null;
  customers:Customer[] = [];
  customer:Customer = null;

  orders:PurchaseOrder[] = [];

  loading:boolean = false;

  constructor( private auth:AuthService, private toastr:ToastrManager, private articleServ:ArticleService, private unityServ:UnityService, private modal:NgbModal, private orderServ:PurchaseOrderService, private utl:UtilitiesService, private invServ:InventoryService, private customerServ:CustomerService ) { }

  ngOnInit() {
    this.user = this.auth.getActualUser();
    this.actualUser = `${this.user.name} ${this.user.last_name}`;

    this.loading = true;
    this.articleServ.getArticles().then(articles => {
      this.articles = articles;
      this.article = this.articles[0];
    });
    this.invServ.getWarehouses().then(warehouses => {
      this.warehouses = warehouses;
      this.warehouse = this.warehouses[0];
    });
    this.unityServ.getUnities().then(unities => {
      this.unities = unities;
      this.unity = this.unities[0];
      this.loading = false;
    });
    this.customerServ.getCustomers('Compañia').then(customers => {
      this.customers = customers;
      this.customer = customers[0];
    });
  }

  getTotal() {
    return this.entry.lines.filter(ln => ln.status != 'Cancelado').map(ln => ln.quantity * ln.unit_price * (ln.iva*1 + 1)).reduce((act, ant) => act + ant, 0);
  }

  openModal(m, ord = false) {
    if (ord) {
      this.modal.open(m, { size: 'lg', windowClass: 'bigger-max' });
      if (this.orders.length == 0) {
        this.loadOrders();
      }
    } else {
      this.modal.open(m);
    }
  }

  selectArticle() {
    this.entryLine.article_id = this.article.id;
    this.entryLine.article_name = this.article.name;
    this.entryLine.measure_unit = this.article.measure_unit;
    this.entryLine.warehouse_measure_unit = this.article.warehouse_measure_unit;
    this.entryLine.warehouse_factor = this.article.warehouse_factor;
  }

  selectUnity() {
    this.entryLine.unity_id = this.unity ? this.unity.id : null;
    this.entryLine.customer_id = this.unity ? this.unity.customer.id : null;
    this.entryLine.customer_name = this.unity ? this.unity.customer.name : null;
  }

  selectWarehouse() {
    this.entryLine.warehouse_id = this.warehouse.id;
    this.entryLine.warehouse_name = this.warehouse.name;
  }

  selectCustomer() {
    this.entryLine.customer_id = this.customer ? this.customer.id : null;
    this.entryLine.customer_name = this.customer ? this.customer.name : null;
  }

  save(event) {
    event.preventDefault();
    for (let e of this.entry.lines) {
      if (!e.remission && !e.invoice) {
        this.toastr.infoToastr("Cada articulo debe tener o una factura o una remisión");
        return;
      }
    }
    this.loading = true;
    this.invServ.postEntry(this.entry).then(entry => {
      this.entry = new Entry();
      this.toastr.successToastr(`Entrada creada con el número ${entry.id}`);
      this.loadOrders();
    }).catch(e => {
      this.toastr.errorToastr(this.utl.formatMessages(e));
      this.loading = false;
    });
  }

  addline() {
    if (this.entryLine.article_id && this.entryLine.quantity && this.entryLine.customer_id && this.entryLine.warehouse_id && this.entryLine.unit_price) {
      if (!this.entryLine.invoice && !this.entryLine.remission) {
        this.toastr.infoToastr("Debe tener o una factura o una remisión");
      } else {
        this.entry.lines.push(Object.assign({}, this.entryLine));
        this.entryLine = new EntryLine();
      }
    } else {
      this.toastr.infoToastr("El artículo, la cantidad, la empresa, el almacén y el precio son campos obligatorios!");
    }
  }

  loadOrders() {
    this.loading = true;
    this.orderServ.getOpenOrders().then(orders => {
      this.orders = orders.filter(o => o.authorized);
      this.loading = false;
    });
  }

  selectOrders() {
    for(let i = 0; i < this.orders.length; i++) {
      let selectedLinesTmp = this.orders[i].lines.filter(line => line.selected);
      for (let j = 0; j < selectedLinesTmp.length; j++) {
        if (!this.entry.lines.find(ln => ln.purchase_order_line_id == selectedLinesTmp[j].id)) {
          this.entry.lines.push({
            article_id: selectedLinesTmp[j].article_id,
            article_name: selectedLinesTmp[j].article_name,
            id: 0,
            iva: selectedLinesTmp[j].iva,
            quantity: selectedLinesTmp[j].missing_quantity,
            purchase_order_line_id: selectedLinesTmp[j].id,
            purchase_order_id: this.orders[i].id,
            selected: true,
            status: 'Abierto',
            unit_price: selectedLinesTmp[j].unit_price,
            unity_id: selectedLinesTmp[j].unity_id,
            entry_id: 0,
            warehouse_id: this.user.warehouse_id,
            warehouse_name: this.warehouses.find(x => x.id == this.user.warehouse_id).name,
            description: selectedLinesTmp[j].description,
            customer_id: selectedLinesTmp[j].customer_id,
            customer_name: selectedLinesTmp[j].customer_name,
            discount: selectedLinesTmp[j].discount,
            measure_unit: selectedLinesTmp[j].measure_unit,
            invoice: '',
            warehouse_factor: selectedLinesTmp[j].warehouse_factor,
            warehouse_measure_unit: selectedLinesTmp[j].warehouse_measure_unit,
            authorized: false,
            deliver_to: "",
            output_date: new Date(),
            warehouse_user_id: 0,
            warehouse_user: null,
            deliver: false,
            remission:'',
            edit:false
          });
        }
      }
    }
  }

  removeLine(line:EntryLine) {
    this.entry.lines = this.entry.lines.filter(l => l != line);
  }
}
